import React, { useState } from 'react';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-collapse.svg';
import {
  BoxInfoHelp,
  ItemListProvider,
  ProviderImg,
  ProviderInfo,
} from './styles';
import Button from '../../../../components/Button';
import { Provider } from '.';
import ConfirmDisassociate from './ConfirmDisassociate';
import Action from '../../../../components/Section/Action';

export const getInfoMessage = (provider: Provider) => {
  if (provider.slug === 'globosat') {
    return {
      confirmDelete: (
        <div>
          <p>
            Ao continuar, a sua Conta Globo deixará de ter acesso aos conteúdos
            do Canais Globo.
          </p>
          <p>
            Se houver compartilhamento familiar, os integrantes de sua conta
            família também não terão mais acesso.
          </p>
        </div>
      ),
      info: 'Permite acesso aos conteúdos online do Canais Globo.',
    };
  }
  if (provider.international) {
    return {
      confirmDelete: (
        <div>
          <p>
            Ao continuar, você deixará de ter acesso aos conteúdos exclusivos do
            Globoplay disponibilizados por essa operadora.
          </p>
          <p>
            Essa ação <strong>não altera ou cancela</strong> seu plano
            contratado junto à operadora.
          </p>
        </div>
      ),
      info: 'O plano contratado nessa operadora permite acesso ao Globoplay.',
    };
  }
  return {
    confirmDelete: (
      <div>
        <p>
          Ao continuar, a sua Conta Globo deixará de ter acesso aos conteúdos
          online dos canais disponibilizados por essa operadora.
        </p>
        <p>
          Se houver compartilhamento familiar, os integrantes de sua conta
          família também não terão mais acesso.
        </p>
        <p>
          Essa ação <strong>não altera ou cancela</strong> seu plano contratado
          junto à operadora.
        </p>
      </div>
    ),
    info: 'O plano contratado nessa operadora permite acesso aos conteúdos online dos canais do seu pacote.',
  };
};

type Props = {
  provider: Provider;
  removeProvider: any;
};

const CollapsibleProvider = ({ provider, removeProvider }: Props) => {
  const [openInfo, setOpenInfo] = useState<boolean>(false);
  const [openConfirmDisassociateModal, setOpenConfirmDisassociateModal] =
    useState<boolean>(false);

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('pt-BR');
  };

  const openCollapsible = () => {
    setOpenInfo(!openInfo);
  };

  return (
    <ItemListProvider>
      <Action
        aria-expanded={openInfo}
        aria-haspopup="true"
        onClick={openCollapsible}
        type="button"
        theme="button"
      >
        <div>
          <ProviderImg
            aria-hidden
            src={provider.image}
            alt={`${provider.name}-icon`}
          />
          <p>{provider.name}</p>
        </div>

        <Icon openCollapsible={openInfo} svg={svg} alt="icon-open-menu" />
      </Action>
      {openInfo && (
        <ProviderInfo id={`providerInfo_${provider.ueid}`}>
          <p>{getInfoMessage(provider).info}</p>
          <div>
            <span>
              Associada em {formatDate(provider.association_date)}{' '}
              {provider.international && '– Estados Unidos'}
            </span>
          </div>
          <Button
            onClick={(e: any) => {
              if (e.currentTarget === e.target) {
                setOpenConfirmDisassociateModal(true);
              }
            }}
            variant="primary"
          >
            Desassociar Operadora
          </Button>
          {openConfirmDisassociateModal && (
            <ConfirmDisassociate
              provider={provider}
              removeProvider={removeProvider}
              openConfirmDisassociateModal={openConfirmDisassociateModal}
              setOpenConfirmDisassociateModal={setOpenConfirmDisassociateModal}
            />
          )}
          <BoxInfoHelp>
            <a href="https://ajuda.globo.com" target="_blank" rel="noreferrer">
              Acessar Ajuda
            </a>
            <a
              href="https://ajuda.globo.com/s/atendimentonaoassinante"
              target="_blank"
              rel="noreferrer"
            >
              Falar com Atendimento
            </a>
          </BoxInfoHelp>
        </ProviderInfo>
      )}
    </ItemListProvider>
  );
};

export default CollapsibleProvider;
